// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__SQWBs","content":"NotFound_content__KFQqa","title":"NotFound_title__xTphS","button":"NotFound_button__O2CDm"};